<template>
  <div
    class="details-table-left"
    :class="{
      [`details-table-left--${sizeCalculated}`]: sizeCalculated,
      'details-table-left--align-center': alignCenter,
      'details-table-left--mobile-align-center': mobileAlignCenter,
      'details-table-left--mobile': isMobileView,
    }"
  >
    <tm-skeleton
      v-if="loading"
      type="QChip"
      random-width
      height="12px"
    />

    <slot v-else>
      <div
        :class="{
          'details-table-left__content--disabled': disabled,
        }"
      >
        {{ label }}

        <tm-tooltip
          v-if="tooltip"
          position="bottom"
          max-width="218px"
        >
          <div class="text-center">
            {{ tooltip }}
          </div>
        </tm-tooltip>
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@/composition/vue/compositionApi'
import TmTooltip from '@/components/shared/tooltip/TmTooltip.vue'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import { useDetailsTableLabelSize } from '@/composition/detailsTable'

const props = defineProps<{
  label?: string
  size?: '' | 'large' | 'xLarge'
  alignCenter?: boolean
  mobileAlignCenter?: boolean
  tooltip?: string
  disabled?: boolean
  loading?: boolean
  isMobileView: boolean
}>()

const sizeInjected = useDetailsTableLabelSize().inject()
const sizeCalculated = computed(() => props.size || sizeInjected?.value)
</script>

<style lang="scss" scoped>
.details-table-left {
  display: flex;
  flex-shrink: 0;
  padding: 10px 16px;
  width: var(--details-table-left-width, 220px);
  min-width: var(--details-table-left-min-width, auto);
  max-width: var(--details-table-left-max-width, auto);
  background-color: $lift;
  font-weight: $semi-bold-font;
  justify-content: flex-end;
  align-items: flex-start;
  border-right: 1px solid $border-color;
  text-align: right;

  &--align-center {
    align-items: center;
  }
  &--large {
    width: var(--details-table-left-width, 260px);
  }
  &--xLarge {
    width: var(--details-table-left-width, 300px);
  }
  &--mobile {
    padding: 12px 12px 0;
    background-color: unset;
    width: auto;
    place-content: center left;
    border-right: none;
    text-align: left;

    &.details-table-left--align-center {
      place-content: center left;
    }

    &.details-table-left--mobile-align-center {
      padding: 12px;
    }
  }

  &__content {
    &--disabled {
      opacity: 0.5;
    }
  }
}
</style>
